<template>
  <div>
    <SAIOrgHeader
      v-if="!isMobile"
      :org-contact-email="orgContactEmail"
      :org-contact-phone="orgContactPhone"
    />
    <SAIApplicationHeader
      :logo="logo"
      :alert="alert"
      :profile-name="profileName"
      :profile-email="profileEmail"
      :display-menu="isMobile"
      :hide-logout="loggedOut"
      :org-contact-email="orgContactEmail"
      :org-contact-phone="orgContactPhone"
      profile-icon="icon-person-outline"
      @logout="$emit('logout')"
      @click:menu="$emit('click:menu')"
    >
      <template v-slot:header-right v-if="!isMobile && !loggedOut">
        <QTabs dense indicator-color="transparent" class="text-grey-6 q-mr-md">
          <QRouteTab
            active-class="text-primary"
            v-for="tab in tabs"
            :key="tab.name"
            v-bind="tab"
            no-caps
            :ripple="false"
            @click="(event) => handleTabClick(tab, event)"
          />
        </QTabs>
        <InLifeCreate
          class="q-mr-md"
          :list="createOptions"
          @create="$emit('create', $event)"
        />
        <SAIBtnAlert
          padding="6px 12px"
          label="REQUESTS"
          class="q-mr-md"
          :alerts="approvals"
          v-if="canSeeApprovals"
          :to="{ name: $RouteNames.hrApprovals }"
        />
      </template>

      <QItem v-close-popup clickable v-if="loggedOut" @click="$emit('logIn')">
        <QItemSection>Login</QItemSection>
      </QItem>
      <UserProfileMenuView
        v-if="isProfileSetupComplete"
        @view="$emit('open:profile-page')"
      />
      <UserProfileMenuStepper
        v-else-if="canEditProfile"
        class="q-my-sm"
        :completion="profileSetupCompletePercentage"
        @complete="$emit('open:profile-setup')"
      />
      <QSeparator color="grey-3" v-if="canClearApplication" horizontal />
      <QItem v-if="canClearApplication">
        <QItemSection>
          <SAIBtn
            class="rounded-borders-lg"
            :rounded="false"
            outline
            :no-caps="true"
            color="negative"
            label="Clear application"
            :loading="clearingApplication"
            :disable="clearingApplication"
            padding="sm md"
            @click="$emit('clear:application')"
          />
        </QItemSection>
      </QItem>
    </SAIApplicationHeader>
  </div>
</template>

<script>
import {
  QTabs,
  QRouteTab,
  QItemSection,
  ClosePopup,
  QItem,
  QSeparator,
  Dialog,
} from 'quasar';
import BudgetWarningDialog from '../../molecule/budget-warning-dialog';
import {
  SAIApplicationHeader,
  SAIOrgHeader,
  SAIBtn,
  SAIBtnAlert,
} from 'ecx.saigon.ui.common';

export default {
  name: 'PrimaryHeader',
  props: {
    logo: String,
    canSeeApprovals: Boolean,
    approvals: Number,
    isMobile: Boolean,
    orgContactEmail: String,
    orgContactPhone: String,
    loggedOut: Boolean,
    profileName: String,
    profileEmail: String,
    alert: Number,
    tabs: {
      type: Array,
      default: () => []
    },
    canEditProfile: Boolean,
    isProfileSetupComplete: Boolean,
    profileSetupCompletePercentage: Number,
    canClearApplication: Boolean,
    clearingApplication: Boolean,
    createOptions: {
      type: Array,
      default: () => []
    }
  },
  directives: {
    ClosePopup,
  },
  methods: {
    async handleTabClick(tab, event) {
      event.preventDefault();
      if (tab.name === 'budgets') {
        Dialog.create({
          component: BudgetWarningDialog,
          label: 'Important information',
          okText: 'Ok',
          maxWidth: '835px',
          actionsGrow: true,
          displayHideAction: false,
          justifyCenter: true,
          labelIcon: 'eva-alert-triangle',
          labelIconColor: 'orange',
        }).onOk(() => {
          this.$router.push(tab.to);
        });
      } else {
        this.$router.push(tab.to);
      }
    },
  },
  components: {
    QTabs,
    QRouteTab,
    SAIApplicationHeader,
    SAIOrgHeader,
    SAIBtn,
    QItemSection,
    QItem,
    SAIBtnAlert,
    QSeparator,
    InLifeCreate: () => import('../../molecule/in-life-create'),
    UserProfileMenuView: () => import('../../molecule/user-profile-menu-view'),
    UserProfileMenuStepper: () =>
      import('../../molecule/user-profile-menu-stepper')
  }
};
</script>

<style lang="sass" scoped>
.q-tab::v-deep
  .q-tab__content
    min-width: initial !important

  .q-focus-helper
    opacity: 0 !important

  .q-tab__label
    font-size: 16px
    font-weight: 500
</style>
